/* import __COLOCATED_TEMPLATE__ from './instant-payouts-settings-page.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { Feature as SaasSharedUiFeature } from '@squareup/saas-shared-ui';
import { State as UpsellContentCardState } from '@banking/ui/components/banking/instant-payouts/upsell-content-card';
import { UpsellPromoType } from '@dashboard/shared-constants/restaurants/upsell-promo-type';
// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';
import { InstantAccessRequirementItem, OnboardToInstantAccessRequest, OptInToInstantAccessProgramRequest, OptOutOfInstantAccessProgramRequest, RetrieveInstantAccessRequirementsStateRequest } from '@square/dashboard-protos/models/squareup/inflows/service/external_instant_access_service';
import { InstantAccessProgram } from '@square/dashboard-protos/models/squareup/inflows/instant_access_program_model';
import { feature } from '@square/ember-features/macros';
import { ModalStatus, OptType } from '@squareup/banking-ui-instant-payouts';
const LEARN_MORE_URL = 'https://squareup.com/help/us/en/article/8319-instant-payouts-with-delivery-partners';
function getPlatformLabel(platform) {
  switch (platform) {
    case InstantAccessProgram.Platform.DOORDASH:
      return 'DoorDash';
    case InstantAccessProgram.Platform.UBER_EATS:
      return 'Uber Eats';
    case InstantAccessProgram.Platform.GRUBHUB:
      return 'Grubhub';
    default:
      return '';
  }
}
export const DOORDASH_PLATFORM_LABEL = 'DoorDash';
let InstantPayoutsSettingsPage = (_dec = service('deposits/direct-deposit'), _dec2 = feature('banking-instant-payouts-disable-upsell'), _class = class InstantPayoutsSettingsPage extends Component {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "SaasSharedUiFeature", SaasSharedUiFeature);
    _defineProperty(this, "DOORDASH_PLATFORM_LABEL", DOORDASH_PLATFORM_LABEL);
    _initializerDefineProperty(this, "applicationRouter", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _initializerDefineProperty(this, "directDeposit", _descriptor3, this);
    _initializerDefineProperty(this, "externalInstantAccessApi", _descriptor4, this);
    _initializerDefineProperty(this, "locationSelector", _descriptor5, this);
    _initializerDefineProperty(this, "userSubscriptions", _descriptor6, this);
    _initializerDefineProperty(this, "features", _descriptor7, this);
    _defineProperty(this, "rstUpsellPromoType", UpsellPromoType.INSTANT_PAYOUTS);
    _initializerDefineProperty(this, "instantAccessAccordionItems", _descriptor8, this);
    _initializerDefineProperty(this, "isError", _descriptor9, this);
    _initializerDefineProperty(this, "isLoading", _descriptor10, this);
    _initializerDefineProperty(this, "isOnboardingInstantAccess", _descriptor11, this);
    _initializerDefineProperty(this, "unitToken", _descriptor12, this);
    _initializerDefineProperty(this, "isOptedIn", _descriptor13, this);
    _initializerDefineProperty(this, "showDirectDepositInfoModal", _descriptor14, this);
    _initializerDefineProperty(this, "showInstantPayoutsUpsellFlow", _descriptor15, this);
    _initializerDefineProperty(this, "showPlusUpsellSheet", _descriptor16, this);
    _initializerDefineProperty(this, "isCheckoutSuccessModalActive", _descriptor17, this);
    _initializerDefineProperty(this, "selectedDepositPlatform", _descriptor18, this);
    _initializerDefineProperty(this, "showOptConfirmationModal", _descriptor19, this);
    _initializerDefineProperty(this, "optConfirmationModalType", _descriptor20, this);
    _initializerDefineProperty(this, "optConfirmationPlatformLabel", _descriptor21, this);
    _initializerDefineProperty(this, "optConfirmationPlatform", _descriptor22, this);
    _initializerDefineProperty(this, "isOptConfirmationLoading", _descriptor23, this);
    _initializerDefineProperty(this, "optConfirmationModalStatus", _descriptor24, this);
    _initializerDefineProperty(this, "shouldDisableInstantPayoutsUpsell", _descriptor25, this);
    _initializerDefineProperty(this, "locationName", _descriptor26, this);
    if (args.unitToken) {
      this.unitToken = args.unitToken;
      this.locationName = args.locationName;
      this.updateAccordionItems(args.unitToken);
    } else {
      this.isError = true;
    }
  }
  get hasMultipleLocations() {
    return this.locationSelector.units.length > 1;
  }
  get shouldEnableUpsellFeatures() {
    return !this.shouldDisableInstantPayoutsUpsell;
  }
  get optInMechanism() {
    return this.shouldDisableInstantPayoutsUpsell ? InstantAccessProgram.OptInMechanism.PAID_PLAN_WAIVER : InstantAccessProgram.OptInMechanism.RST_PREM_PLUS_ONBOARDING;
  }
  get isEligibleForUpsell() {
    return this.userSubscriptions.isRestaurantsFreeTrialNoObligation || this.userSubscriptions.isPayingRstSubscriber || this.userSubscriptions.squareOneEligible && this.userSubscriptions.isEntitledToFeature(SaasSharedUiFeature.INSTANT_ACCESS);
  }
  get shouldShowLocationSelector() {
    if (this.shouldDisableInstantPayoutsUpsell) {
      return this.hasMultipleLocations;
    }
    return this.hasMultipleLocations && (!this.userSubscriptions.squareOneEligible || this.userSubscriptions.isEntitledToFeature(SaasSharedUiFeature.INSTANT_ACCESS));
  }
  get shouldShowNagBanner() {
    if (!this.shouldEnableUpsellFeatures) {
      return false;
    }
    return this.userSubscriptions.isRestaurantsFreeTrialNoObligation && !this.userSubscriptions.squareOneEligible;
  }
  get shouldShowSubtitle() {
    if (this.shouldDisableInstantPayoutsUpsell) {
      return true;
    }
    return !this.userSubscriptions.squareOneEligible || this.userSubscriptions.isEntitledToFeature(SaasSharedUiFeature.INSTANT_ACCESS);
  }
  get shouldShowUpsellContentCard() {
    if (this.shouldDisableInstantPayoutsUpsell) {
      return true;
    }
    return !this.userSubscriptions.squareOneEligible || this.upsellContentCardState === UpsellContentCardState.GetStarted || this.upsellContentCardState === UpsellContentCardState.Error;
  }
  get shouldShowSetupPageRedesign() {
    return !this.isOptedIn;
  }
  get upsellContentCardState() {
    if (this.isError) {
      return UpsellContentCardState.Error;
    }
    if (this.shouldDisableInstantPayoutsUpsell) {
      return UpsellContentCardState.GetStarted;
    }
    return this.isEligibleForUpsell ? UpsellContentCardState.GetStarted : UpsellContentCardState.LearnMore;
  }
  onLocationChange(selectedUnits) {
    const unitToken = selectedUnits[0]?.token;
    this.unitToken = unitToken;
    this.locationName = selectedUnits[0]?.nickname || '';
    if (unitToken) {
      this.updateAccordionItems(unitToken);
    }
    // record unitToken in the URL, so it remembers the unit when page is backed or forwarded
    this.applicationRouter.transitionTo({
      queryParams: {
        unitToken
      }
    });
  }
  _resetErrorAndOptInState() {
    this.isOptedIn = false;
    this.isError = false;
  }
  async updateAccordionItems(unitToken) {
    this.isLoading = true;
    this._resetErrorAndOptInState();
    try {
      const response = await this.externalInstantAccessApi.client.retrieveInstantAccessRequirementsState(RetrieveInstantAccessRequirementsStateRequest.create({
        unitToken
      }));
      if (response.success?.accordionItems) {
        this.isOptedIn = response.success.optedIn;
        this.instantAccessAccordionItems = response.success.accordionItems;
      } else if (response.failure) {
        this.instantAccessAccordionItems = [];
        this.isError = true;
      }
    } catch {
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }
  async onboardInstantAccessForRST() {
    this.isOnboardingInstantAccess = true;
    this._resetErrorAndOptInState();
    try {
      const response = await this.externalInstantAccessApi.client.onboardToInstantAccess(OnboardToInstantAccessRequest.create({
        unitTokens: [this.unitToken],
        optInMechanism: this.optInMechanism
      }));
      if (response.success) {
        await this.updateAccordionItems(this.unitToken);
      } else if (response.failure) {
        this.isError = true;
      }
    } catch {
      this.isError = true;
    } finally {
      this.isOnboardingInstantAccess = false;
    }
  }
  async onClickDirectDepositItem(accordionItem) {
    const balanceOverviewUrl = `/dashboard/balance/overview?unitToken=${encodeURIComponent(this.unitToken)}`;
    try {
      await this.directDeposit.viewDirectDepositAccountDetails(this.unitToken);
      if (this.directDeposit?.directDepositAccount?.accountNumber) {
        this.selectedDepositPlatform = accordionItem?.platform ?? InstantAccessProgram.Platform.UNKNOWN_PLATFORM_DO_NOT_USE;
        this.showDirectDepositInfoModal = true;
        return;
      }
      theWindow.open(balanceOverviewUrl);
    } catch {
      this.isError = true;
      theWindow.open(balanceOverviewUrl);
    }
  }
  closeDirectDepositInfoModal() {
    this.showDirectDepositInfoModal = false;
  }
  onOpenHelpPage() {
    theWindow.open(LEARN_MORE_URL, '_blank', 'noopener noreferrer');
  }
  openRstCheckoutSuccessModal() {
    this.dataApi.track('Exit Instant Payouts Setup Modal');
    if (!this.isOptedIn) {
      this.isCheckoutSuccessModalActive = true;
    }
  }
  closeRstCheckoutSuccessModal() {
    this.isCheckoutSuccessModalActive = false;
    if (!this.isOptedIn) {
      this.onboardInstantAccessForRST();
    }
  }
  openRstUpsellSheet() {
    // RST Legacy users will see the older RestaurantsPlusUpsellSheet flow
    if (this.userSubscriptions.isNewRstTierSubscriptionUser) {
      this.showInstantPayoutsUpsellFlow = true;
    } else {
      this.showPlusUpsellSheet = true;
    }
  }
  onChecklistAccordionRowClick(requirementItem, accordionItem) {
    if (requirementItem.type === InstantAccessRequirementItem.Type.ORDERS_INTEGRATION_SETUP) {
      if (this.args.handleOrdersIntegrationSetup) {
        this.args.handleOrdersIntegrationSetup();
      }
    } else if (requirementItem.type === InstantAccessRequirementItem.Type.ACTIVE_CHECKING_ACCOUNT) {
      const checkingOnboardingRouteName = 'banking.checking';
      const returnToRoute = `ember://orders-instant-payouts-settings?unitToken=${this.args.unitToken}`;
      this.applicationRouter.transitionTo(checkingOnboardingRouteName, {
        queryParams: {
          unitToken: this.args.unitToken,
          start: 'true',
          returnTo: encodeURIComponent(returnToRoute)
        }
      });
    } else if (requirementItem.type === InstantAccessRequirementItem.Type.DIRECT_DEPOSITS_SETUP) {
      this.onClickDirectDepositItem(accordionItem);
    } else if (requirementItem.type === InstantAccessRequirementItem.Type.DEACTIVATE_INSTANT_PAYOUTS) {
      this._openOptConfirmationModal(OptType.OPT_OUT, accordionItem);
    } else if (requirementItem.type === InstantAccessRequirementItem.Type.REACTIVATE_INSTANT_PAYOUTS) {
      this._openOptConfirmationModal(OptType.OPT_IN, accordionItem);
    }
  }
  _openOptConfirmationModal(optType, accordionItem) {
    this.optConfirmationModalType = optType;
    this.optConfirmationPlatformLabel = getPlatformLabel(accordionItem.platform);
    this.optConfirmationPlatform = accordionItem.platform;
    this.optConfirmationModalStatus = ModalStatus.CONFIRMATION;
    this.showOptConfirmationModal = true;
  }
  closeOptConfirmationModal() {
    this.showOptConfirmationModal = false;
    this.optConfirmationPlatformLabel = '';
    this.optConfirmationPlatform = InstantAccessProgram.Platform.UNKNOWN_PLATFORM_DO_NOT_USE;
    this.optConfirmationModalStatus = ModalStatus.CONFIRMATION;
  }
  async onOptConfirmationConfirm() {
    this.isOptConfirmationLoading = true;
    try {
      let response;
      if (this.optConfirmationModalType === OptType.OPT_OUT) {
        response = await this.externalInstantAccessApi.client.optOutOfInstantAccessProgram(OptOutOfInstantAccessProgramRequest.create({
          unitToken: this.unitToken,
          platform: this.optConfirmationPlatform
        }));
      } else {
        response = await this.externalInstantAccessApi.client.optInToInstantAccessProgram(OptInToInstantAccessProgramRequest.create({
          unitToken: this.unitToken,
          platform: this.optConfirmationPlatform,
          optInMechanism: this.shouldDisableInstantPayoutsUpsell ? InstantAccessProgram.OptInMechanism.PAID_PLAN_WAIVER : InstantAccessProgram.OptInMechanism.RST_PREM_PLUS_ONBOARDING
        }));
      }
      if (response.success) {
        this.optConfirmationModalStatus = ModalStatus.SUCCESS;
        await this.updateAccordionItems(this.unitToken);
      } else {
        this.optConfirmationModalStatus = ModalStatus.ERROR;
      }
    } catch {
      this.optConfirmationModalStatus = ModalStatus.ERROR;
    } finally {
      this.isOptConfirmationLoading = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "directDeposit", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "externalInstantAccessApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "instantAccessAccordionItems", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isOnboardingInstantAccess", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "unitToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "isOptedIn", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showDirectDepositInfoModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showInstantPayoutsUpsellFlow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "showPlusUpsellSheet", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "isCheckoutSuccessModalActive", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "selectedDepositPlatform", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return InstantAccessProgram.Platform.UNKNOWN_PLATFORM_DO_NOT_USE;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "showOptConfirmationModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "optConfirmationModalType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return OptType.OPT_IN;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "optConfirmationPlatformLabel", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "optConfirmationPlatform", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return InstantAccessProgram.Platform.UNKNOWN_PLATFORM_DO_NOT_USE;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "isOptConfirmationLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "optConfirmationModalStatus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ModalStatus.CONFIRMATION;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "shouldDisableInstantPayoutsUpsell", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "locationName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "onLocationChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onLocationChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onboardInstantAccessForRST", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onboardInstantAccessForRST"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickDirectDepositItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickDirectDepositItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDirectDepositInfoModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDirectDepositInfoModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onOpenHelpPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onOpenHelpPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openRstCheckoutSuccessModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openRstCheckoutSuccessModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeRstCheckoutSuccessModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeRstCheckoutSuccessModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openRstUpsellSheet", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openRstUpsellSheet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChecklistAccordionRowClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChecklistAccordionRowClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeOptConfirmationModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeOptConfirmationModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onOptConfirmationConfirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onOptConfirmationConfirm"), _class.prototype), _class);
export { InstantPayoutsSettingsPage as default };